import React from 'react';
import { connect } from 'react-redux';
import { editarNumeroPatronal, guardarNumeroPatronal } from '../../components/numeroPatronal/NumeroPatronalService'
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import { validateForm } from "../../constans/validationUtils";
import BreadCrumComponent from '../../components/componentes/BreadCrumComponent';
import {
  mostrarErroresEnFormulario, configurarLimpiezaAutomatica, integrarConChkClick,
  integrarConHandleInput
} from '../../constans/form-error-utils';

class NumeroPatronal extends React.Component {

  constructor(props) {
    super(props);

    const { tipoAccion } = props.match.params;

    const originalHandleInput = this.handleInput;

    this.handleInput = integrarConHandleInput(this, originalHandleInput);

    this.state = {
      numeroPatronal: "",
      descripcion: "",
      errors: {
        numeroPatronal: null,
        descripcion: null
      },
      id: "",
      mostrarMensaje: false,
      mensaje: "",
      severity: "",
      openPantallaCarga: false,
      tipoAccion,
      titulo: null
    }
  }

  reglasValidacionCampos = {
    numeroPatronal: [
      { customValidator: (value, formData) => { return /^\d+$/.test(value) }, message: 'Ingrese un número válido' },
    ],
    descripcion: [
      { required: true, message: 'Ingrese una descripcion' },
    ]
  }

  handleClose = () => {
    this.props.handleClose(false, this.state.mensaje, this.state.severity);
  }

  handleNumeroPatronalSubmit = event => {
    event.preventDefault();
    const { isValid, errors } = validateForm(this.state, this.reglasValidacionCampos);
    if (isValid) {
      mostrarErroresEnFormulario({});
      this.setState({ openPantallaCarga: true });
      if (this.state.tipoAccion === "edit") {
        const json = {
          numeroPatronal: this.state.numeroPatronal,
          descripcion: this.state.descripcion,
          id: this.state.id
        };
        this.props.editarNumeroPatronal(json).then((response) => {
          this.props.history.push({
            pathname: `/configuracion/numero-patronal`,
            state: {
              mensajeFlash: response.mensaje,
              mostrarMensajeFlash: true,
              mensajeFlashSeverity: response.error ? "error" : "exito",
            }
          });
        });
      } else {
        const json = {
          numeroPatronal: this.state.numeroPatronal,
          descripcion: this.state.descripcion,
          id: this.state.id
        };
        this.props.guardarNumeroPatronal(json).then((response) => {
          this.props.history.push({
            pathname: `/configuracion/numero-patronal`,
            state: {
              mensajeFlash: response.mensaje,
              mostrarMensajeFlash: true,
              mensajeFlashSeverity: response.error ? "error" : "exito",
            }
          });
        });
      }
    } else {
      this.setState({ errors: errors, showErrors: true });
      mostrarErroresEnFormulario(errors); 
    }

  }

  componentDidMount() {
    
    configurarLimpiezaAutomatica();

    if (this.state.tipoAccion === "edit") {
      const { numeroPatronal } = this.props.location.state;
      this.setState({
        numeroPatronal: numeroPatronal.numero,
        descripcion: numeroPatronal.descripcion,
        id: numeroPatronal.id,
        titulo: "Datos de " + numeroPatronal.descripcion
      })
    }
  }

  handleInput = (e) => {
    var name = e.target.name
    var val = e.target.value
    this.setState(prevState => ({
      errors: {
        ...prevState.errors,
        [name]: null
      },
      [name]: val,
    }))
  }

  actualizarDatosTabla = () => {
    if (this.tablaRef) {
      this.tablaRef.fetchData();
    }
  }

  render() {
    return (
      <div>
        <div className="template-base">
          <header className="component-header">
            <div className="page-container">
              <BreadCrumComponent
                backUrl={'/configuracion/numero-patronal'}
                breadcrumbs={
                  [
                    { label: 'Configuraciones', path: '/configuracion/tipo-documento' },
                    { label: 'Número MTESS Patronal', path: '/configuracion/numero-patronal' },
                    { label: this.props.match.params.tipoAccion !== 'edit' ? 'Registrar número patronal' : 'Editar número patronal', path: '' }
                  ]
                }
              />
              <div className="head-area">
                <div className="caption-area">
                  <h1 className="page-title"> {this.state.titulo ?? "Registrar nueva número patronal"} </h1>
                  <p className="page-description"> Complete el siguiente formulario con los datos solicitados </p>
                </div>
              </div>
            </div>
          </header>
          <div className="wrapperContent">
            <div className="page-container">

              <div className="component-content card">
                <form onSubmit={this.handleNumeroPatronalSubmit} className="form container-sm">

                  <div className="form-group">
                    <input type="number" name="numeroPatronal" id="numeroPatronal" className="form-input" onChange={this.handleInput} value={this.state.numeroPatronal} />
                    <label htmlFor="numeroPatronal" className="form-label"> Número Patronal </label>
                  </div>

                  <div className="form-group">
                    <input type="text" name="descripcion" id="descripcion" className="form-input" onChange={this.handleInput} value={this.state.descripcion} />
                    <label htmlFor="descripcion" className="form-label"> Descripción </label>
                  </div>
                  <div className="form-actions">
                    <button type="submit" className="btn-medium btn-primary"> GUARDAR </button>
                  </div>

                </form>
              </div>
            </div>
          </div>
          <PantallaCarga open={this.state.openPantallaCarga}/>
        </div>
      </div>
    )
  }

}

const mapDispatchToProps = dispatch => ({
  guardarNumeroPatronal: value => dispatch(guardarNumeroPatronal(value)),
  editarNumeroPatronal: value => dispatch(editarNumeroPatronal(value))
});

export default connect(null, mapDispatchToProps)(NumeroPatronal);